export interface Config {
	env: string;
	appURL: URL;
	alpaca: {
		baseUrl: string;
        dataUrl: string;
		keyId: string;
		secretKey: string;
	};
	authConfig: {
        authority: string;
		cognito_domain: string;
        client_id: string;
        redirect_uri: string;
        response_type: string;
        scope: string;
    };
    todoist: {
        accessToken: string;
        baseUrl: string;
        projectId: string;
    };
}

declare global {
	interface Window {
		env: {
			env: string;
			appURL: string;
			alpaca: {
				baseUrl: string;
				dataUrl: string;
				keyId: string;
				secretKey: string;
			};
			authConfig: {
				authority: string;
				cognito_domain: string;
				client_id: string;
				redirect_uri: string;
				response_type: string;
				scope: string;
			};
			todoist: {
				accessToken: string;
				baseUrl: string;
				projectId: string;
			};
        };
	}
}

export const config: Config = {
	env: window.env.env,
	appURL: new URL(window.env.appURL),
	alpaca: {
		baseUrl: window.env.alpaca.baseUrl,
		dataUrl: window.env.alpaca.dataUrl,
		keyId: window.env.alpaca.keyId,
		secretKey: window.env.alpaca.secretKey
	},
	authConfig: {
        authority: window.env.authConfig.authority,
		cognito_domain: window.env.authConfig.cognito_domain,
        client_id: window.env.authConfig.client_id,
        redirect_uri: window.env.authConfig.redirect_uri,
        response_type: window.env.authConfig.response_type,
        scope: window.env.authConfig.scope
    },
    todoist: {
        accessToken: window.env.todoist.accessToken,
        baseUrl: window.env.todoist.baseUrl,
        projectId: window.env.todoist.projectId
    }
};